<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="IconRect">
      <div class="tools" @click="rotateImg"><i class="iconfont iconrotate" /></div>
      <vueCropper
        ref="cropper"
        class="cutIconRect"
        :img="option.img"
        :output-size="option.size"
        :output-type="option.outputType"
        :info="false"
        :full="option.full"
        :can-move="option.canMove"
        :can-move-box="option.canMoveBox"
        :original="option.original"
        :auto-crop="option.autoCrop"
        :fixed="option.fixed"
        :fixed-number="option.fixedNumber"
        :center-box="option.centerBox"
        :fixed-box="option.fixedBox"
        :max-img-size="option.maxImgSize"
        :enlarge="option.enlarge"
      />
      <van-uploader :after-read="onRead" style="width: 50% !important;">
        <van-button plain type="info" size="large" :color="GetColorMain()">选择照片</van-button>
      </van-uploader>

      <van-button type="info" size="large" style="width:50%;" :loading="uploadIconLoading" loading-text="上传中..." :color="GetColorMain()" @click="uploadIcon">上传</van-button>
    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import TopBar from '@/components/TopBar'
import { MyNotify } from '@/utils/base'
import { Button, Uploader } from 'vant'
import { VueCropper } from 'vue-cropper'
import commonData from '@/commondata.js'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine, getUserBase } from '@/utils/base'

export default {
  components: {
    [Button.name]: Button,
    [Uploader.name]: Uploader,
    TopBar,
    VueCropper
  },
  data() {
    return {
      option: {
        img: '', // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 1, // 裁剪生成图片的质量
        outputType: 'png', // 裁剪生成图片的格式
        canScale: true, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        fixedBox: true, // 固定截图框大小 不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [10, 10], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: false, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        maxImgSize: 2000,
        enlarge: 1
      },
      title: '更换头像',
      backurl: '/my/index',
      uploadIconLoading: false
    }
  },
  created() {
    getUserBase(userInfo => {
      console.log('用户数据', userInfo)
    })
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    uploadIcon() {
      var height = this.$refs.cropper.cropH
      console.log(height)
      var bl = 130.0 / height
      console.log(bl)
      this.option.enlarge = bl
      this.$refs.cropper.getCropData((data) => {
        request({
          url: '/user/updataUserIcon',
          method: 'post',
          data: { data: data }
        }).then(response => {
          if (!response.success) {
            return
          }
          commonData.userBase = undefined
          MyNotify('success', '头像修改成功', 3000)
          window.history.length > 1
            ? this.$router.go(-1)
            : this.$router.push('/my/index')
        })
      })
    },
    onRead(file) {
      this.option.img = file.content
    },
    rotateImg() {
      if (this.option.img === undefined || this.option.img == null || this.option.img === '') {
        return
      }
      this.$refs.cropper.rotateRight()
    }

  }
}
</script>
<style>

.van-uploader__input-wrapper{
  width: 100% !important;
}
.uploadbutton button{
  width: 100%;
}
</style>
<style scoped>
.cutIconRect{
    width: 100%;
    height: 26em !important;
}
.tools{
  position: absolute;
  right: 1.5em;
  top:4.5em;
  z-index: 999;
  width: 2em;
  height: 2em;
  line-height: 2em;
  border-radius: 1em;
  text-align: center;
  background-color: #fff;
}

.IconRect{
  margin: 1em 1em 0 1em;
  border-radius: 0.5em;
  overflow: hidden;
}
</style>
